import {AnyAction} from 'redux';
import {SET_ENERGY_DEMAND} from '../action';


/**
 * set the amount of energy demanded
 */
export function setEnergyDemand(demand: number) : AnyAction
{
    return {type: SET_ENERGY_DEMAND, payload: {demand}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/energy/setEnergyDemand.ts